export default "__VITE_ASSET__CzS$qGL4__"